const localFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Lisbon', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
})

export function lisbonDateTimeInput(value: unknown): string {
  if (!value) return ''
  // Preserve old timezone-less values for explicit correction, never infer the browser timezone.
  if (typeof value === 'string' && /^\d{4}-\d\d-\d\dT\d\d:\d\d$/.test(value)) return value
  const date = new Date(String(value))
  if (!Number.isFinite(date.getTime())) return ''
  const parts = Object.fromEntries(localFormatter.formatToParts(date).map(({ type, value }) => [type, value]))
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`
}

export function lisbonInputToIso(value: string, original?: unknown): string {
  if (!value) return ''
  if (!/^\d{4}-\d\d-\d\dT\d\d:\d\d$/.test(value)) throw new Error('Enter a valid Lisbon date and time.')
  const wallTime = Date.parse(`${value}:00Z`)
  if (!Number.isFinite(wallTime) || new Date(wallTime).toISOString().slice(0, 16) !== value) throw new Error('Enter a valid Lisbon date and time.')
  // Keep a saved instant (including its DST offset/seconds) when its displayed time did not change.
  if (typeof original === 'string' && /(?:Z|[+-]\d\d:\d\d)$/.test(original) && lisbonDateTimeInput(original) === value) return new Date(original).toISOString()
  const offsets = new Set([-86400000, 0, 86400000].map((delta) => {
    const instant = wallTime + delta
    return Date.parse(`${lisbonDateTimeInput(new Date(instant).toISOString())}:00Z`) - instant
  }))
  const matches = [...offsets].map((offset) => new Date(wallTime - offset).toISOString()).filter((instant) => lisbonDateTimeInput(instant) === value)
  if (matches.length !== 1) throw new Error(matches.length
    ? 'This Lisbon time occurs twice when the clocks change. Choose an unambiguous appointment time.'
    : 'This Lisbon time does not exist because the clocks change. Choose another appointment time.')
  return matches[0]
}
